const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/allowedAppointmentTypes.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';

export const REQUEST_ACTION_TYPES_ALLOWED_APPOINTMENT_TYPES = kisapiActionTypes(
    'REQUEST_ACTION_TYPES_ALLOWED_APPOINTMENT_TYPES'
);
export const REQUEST_ACTION_TYPES_ALLOWED_ECHECKIN_APPOINTMENT_TYPES = kisapiActionTypes(
    'REQUEST_ACTION_TYPES_ALLOWED_ECHECKIN_APPOINTMENT_TYPES'
);

export function loadAllowedAppointmentTypes() {
    const endpoint = `/settings/allowedAppointmentTypes`;
    return createPatapiCall(REQUEST_ACTION_TYPES_ALLOWED_APPOINTMENT_TYPES, endpoint, HttpMethod.GET);
}

export function loadAllowedEchekinAppointmentTypes() {
    const endpoint = `/settings/allowedEcheckinAppointmentSettings`;
    return createPatapiCall(REQUEST_ACTION_TYPES_ALLOWED_ECHECKIN_APPOINTMENT_TYPES, endpoint, HttpMethod.GET);
}
